module.exports = __webpack_public_path__ + "static/media/buy-stock.eea4c9ed.png";